const Admin = {
  newHome: '/admin/new-home'
}

const Auth = {
  login: '/auth/login',
  register: '/auth/register'
}

const App = {
  home: '/',
  round: '/round',
  admin: Admin,
  auth: Auth
}

export const ROUTES = {
  ...App
}
